<template>
  <div class="users">
    <div class="begin">
      <div class="header">
        <div class="flex items-center justify-end">
          <div class="flex-one current-month ">
            <div class="search-bloc flex items-center justify-between">
              <div class="recherche-name">
                <div class="relative recherche justify-center items-center pl-8 pr-4 py-4 bg-white shadow rounded">
                  <div class="icon-search absolute inset-y-0 left-0 flex items-center px-4">
                    <svg-icon
                      name="ic_search"
                      original
                      class="icon w-4 h-4"
                    />
                  </div>
                  <div class="search-input ml-4">
                    <label>
                      <input
                        v-model="search"
                        type="text"
                        :placeholder="$t('searchName')"
                        class="recherche-input"
                      >
                    </label>
                  </div>
                </div>
              </div>
              <div class="select-pays">
                <user-filter
                  :status-list="professionList"
                  @selectedValue="selectedValueProfession"
                />
              </div>
              <div class="select-pays">
                <town-select
                  :status-list="statusList"
                  @selectedValue="selectedValue"
                />
              </div>
            </div>
          </div>
        </div><br>
      </div>
      <div class="user-list bg-white rounded font-semibold shadow p-6 flex items-center">
        <div class="flex-one item-color w-2/6 mr-4">{{ $t('completeName') }}</div>
        <div class="flex-one item-color w-1/5">{{ $t('phone') }}</div>
        <div class="flex-one item-color w-1/12">{{ $t('sex') }}</div>
        <div class="flex-one item-color w-1/5">{{ $t('profession') }}</div>
        <div class="flex-one item-color w-1/5">{{ $t('town') }}</div>
        <div class="flex-one item-color w-1/5">{{ $t('pseudo') }}</div>
        <div class="flex-one item-color w-1/4">{{ $t('lastLogin') }}</div>
        <div class="flex-one item-color w-1/4">{{ $t('parrainageBilan') }}</div>
        <div class="flex-one item-color w-1/12"></div>
        <div class="w-10 ml-2"></div>
      </div>
      <div class="flex items-center gap-4 mt-2">
        <div
          class="p-4 cursor-pointer inline-block rounded font-semibold"
          :class="viewMode === 'active' ? 'bg-gray-200 text-black' : 'text-gray-600 hover:text-black'"
          @click="switchView('active')"
        >
          Utilisateurs actifs
        </div>
        <div
          class="p-4 cursor-pointer inline-block rounded font-semibold"
          :class="viewMode === 'inactive' ? 'bg-red-100 text-red-700' : 'text-gray-600 hover:text-red-500'"
          @click="switchView('inactive')"
        >
          {{ $t('userSuspended') || 'Utilisateurs suspendus' }}
        </div>
      </div>
      <div class="loading" :class="{ 'not_empty': isLoading === false }">
        <loading
          :active="isLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="fullPage"
          loader="dots"
          color="#0B5382"
          background-color="transparent"
        />
      </div>
      <div class="no-student text-center text-lg py-32" v-if="sortedArrayUser.length === 0 && !isLoading">
        {{ $t('noUserAdd') }}
      </div>
      <div class="list-user cursor-pointer" v-if="sortedArrayUser.length > 0 && !isLoading">
        <users-list
          v-for="(item, i) in sortedArrayUser"
          :key="i"
          :user-list="item"
          :parrainage="parainageByUser[item.userId] || 0"
          :view-mode="viewMode"
          @click.native="showUserDetail(item)"
          @promoteUser="openPromoteConfirm"
          @suspendUser="openSuspendConfirm"
          @reactivateUser="openReactivateConfirm"
        />

        <pagination-base
          :currentPage="currentPage"
          :totalPages="computedTotalPages"
          :visiblePages="computedVisiblePages"
          @page-change="handlePageChange"
        />
      </div><br>
    </div>
    <users-details
      v-if="userDetails"
      @closeUsersDetail="closeUsersDetail"
      :userDetails="selectedItem"
    />

    <popup-base v-if="promoteConfirm" @clickOutside="closePromoteConfirm">
      <div class="begin bg-white m-auto w-1/2 rounded-lg p-8">
        <div class="header flex items-center justify-between">
          <div class="header-title font-medium text-2xl text-black">Promouvoir en Admin</div>
          <div class="delete-icon cursor-pointer" @click="closePromoteConfirm">
            <svg-icon name="ic_close" original class="w-4 h-4"/>
          </div>
        </div><br>
        <div class="body mt-6">
          <div class="title">Voulez-vous vraiment promouvoir cet utilisateur en Admin ?</div><br>
          <div v-if="promoteError" class="text-red-500 text-center mt-2">{{ promoteErrorMessage }}</div>
          <div class="delete-button flex items-center justify-end mt-4">
            <button-base
              :label="$t('cancelButton') || 'Annuler'"
              background="#ECECEC"
              fontcolor="#000000"
              @click.native="closePromoteConfirm"
            />
            <div class="ml-4">
              <button-base
                label="Promouvoir"
                :is-loading="promoteLoader"
                @click.native="promoteUser"
              />
            </div>
          </div>
        </div>
      </div>
    </popup-base>

    <success-add
      v-if="promoteSuccess"
      :message="promoteMessage"
      :button-label="$t('goBackAddMemberButton') || 'Retour'"
      @closeSuccess="closePromoteSuccess"
    />

    <popup-base v-if="statusConfirm" @clickOutside="closeStatusConfirm">
      <div class="begin bg-white m-auto w-1/2 rounded-lg p-8">
        <div class="header flex items-center justify-between">
          <div class="header-title font-medium text-2xl text-black">
            {{ statusAction === 'suspend' ? 'Suspendre l\'utilisateur' : 'Réactiver l\'utilisateur' }}
          </div>
          <div class="delete-icon cursor-pointer" @click="closeStatusConfirm">
            <svg-icon name="ic_close" original class="w-4 h-4"/>
          </div>
        </div><br>
        <div class="body mt-6">
          <div class="title">
            {{ statusAction === 'suspend'
              ? 'Voulez-vous vraiment suspendre cet utilisateur ?'
              : 'Voulez-vous vraiment réactiver cet utilisateur ?' }}
          </div><br>
          <div v-if="statusError" class="text-red-500 text-center mt-2">{{ statusErrorMessage }}</div>
          <div class="delete-button flex items-center justify-end mt-4">
            <button-base
              :label="$t('cancelButton') || 'Annuler'"
              background="#ECECEC"
              fontcolor="#000000"
              @click.native="closeStatusConfirm"
            />
            <div class="ml-4">
              <button-base
                :label="statusAction === 'suspend' ? 'Suspendre' : 'Réactiver'"
                :is-loading="statusLoader"
                @click.native="confirmStatusChange"
              />
            </div>
          </div>
        </div>
      </div>
    </popup-base>

    <success-add
      v-if="statusSuccess"
      :message="statusMessage"
      :button-label="$t('goBackAddMemberButton') || 'Retour'"
      @closeSuccess="closeStatusSuccess"
    />
  </div>
</template>

<script>
import TownSelect from '../../components/helper/town-select'
import UsersList from '../../components/helper/users/users-list'
import UsersDetails from '../../components/helper/users/users-details'
import http from '../../plugins/http'
import apiRoutes from '../../router/api-routes'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import UserFilter from '@/components/helper/users/user-filter'
import towns from '@/components/helper/add/allTowns'
import PaginationBase from '@/components/helper/add/pagination-base.vue'
import PopupBase from '@/components/helper/add/popup-base.vue'
import ButtonBase from '@/components/helper/add/button-base.vue'
import SuccessAdd from '@/components/helper/success-add.vue'

export default {
  name: 'index',
  components: { SuccessAdd, ButtonBase, PopupBase, PaginationBase, UserFilter, Loading, UsersDetails, UsersList, TownSelect },
  data () {
    return {
      userDetails: false,
      search: '',
      statusList: [...towns],
      trieOption: 'all',
      allUsers: [],
      selectedItem: null,
      isLoading: true,
      fullPage: false,
      nothing: false,
      currentPage: 1,
      limit: 10,
      selectedProfession: '',
      parainageByUser: {},
      promoteConfirm: false,
      promoteSuccess: false,
      promoteLoader: false,
      promoteError: false,
      promoteErrorMessage: '',
      promoteMessage: '',
      userToPromote: null,
      statusConfirm: false,
      statusSuccess: false,
      statusLoader: false,
      statusError: false,
      statusErrorMessage: '',
      statusMessage: '',
      statusAction: '',
      userToChangeStatus: null,
      viewMode: 'active',
      professionList: [
        { name: 'Tout', value: 'Tout' },
        { name: 'Animateur', value: 'Animateur' },
        { name: 'Autres', value: 'Autres' },
        { name: 'Commerçant(e)', value: 'Commerçant(e)' },
        { name: 'Elève', value: 'Elève' },
        { name: 'Etudiant(e)', value: 'Etudiant(e)' },
        { name: 'Infirmier(e)', value: 'Infirmier(e)' },
        { name: 'Médécin généraliste', value: 'Médécin généraliste' },
        { name: 'Médécin Spécialiste', value: 'Médécin Spécialiste' },
        { name: 'Sage-femme', value: 'Sage-femme' }
      ]
    }
  },
  computed: {
    filteredUsers () {
      let result = this.allUsers

      if (this.trieOption && this.trieOption !== 'all' && this.trieOption !== 'TOUT') {
        const town = this.trieOption.toLowerCase()
        result = result.filter(u =>
          (u.town || '').toLowerCase() === town ||
          (u.location || '').toLowerCase() === town
        )
      }

      if (this.selectedProfession && this.selectedProfession !== 'Tout') {
        const prof = this.selectedProfession.toLowerCase()
        result = result.filter(u => (u.profession || '').toLowerCase() === prof)
      }

      if (this.search && this.search.trim() !== '') {
        const norm = s => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
        const words = norm(this.search).trim().split(/\s+/).filter(w => w.length > 0)
        result = result.filter(u => {
          const haystack = [u.firstName, u.lastName, u.phone, u.email, u.pseudo]
            .map(norm)
            .join(' ')
          return words.every(word => haystack.includes(word))
        })
      }

      return result
    },
    sortedArrayUser () {
      const start = (this.currentPage - 1) * this.limit
      return this.filteredUsers.slice(start, start + this.limit)
    },
    computedTotalPages () {
      return Math.max(1, Math.ceil(this.filteredUsers.length / this.limit))
    },
    computedVisiblePages () {
      return Math.min(5, this.computedTotalPages)
    }
  },
  watch: {
    search () { this.currentPage = 1 },
    trieOption () { this.currentPage = 1 },
    selectedProfession () { this.currentPage = 1 },
    sortedArrayUser: {
      handler (newVal) {
        if (this.viewMode === 'active') this.loadParrainageForVisible(newVal)
      },
      immediate: false
    }
  },
  created () {
    this.loadAllUsers()
  },
  mounted () {
    this.statusList.sort(function (x, y) {
      const a = x.name.toUpperCase()
      const b = y.name.toUpperCase()
      return a === b ? 0 : a > b ? 1 : -1
    })
    const all = { name: 'TOUT' }
    this.statusList.unshift(all)
  },
  methods: {
    handlePageChange (newPage) {
      this.currentPage = newPage
    },
    switchView (mode) {
      if (this.viewMode === mode) return
      this.viewMode = mode
      this.currentPage = 1
      if (mode === 'inactive') {
        this.loadInactiveUsers()
      } else {
        this.loadAllUsers()
      }
    },
    loadInactiveUsers () {
      this.isLoading = true
      this.allUsers = []
      http.post(apiRoutes.baseURL + apiRoutes.getAllInactiveUser, {
        type: 'USER',
        page: 1,
        limit: 10000
      }, {
        headers: { Authorization: `Bearer ${this.$store.getters.loginToken}` }
      })
        .then(response => {
          const rows = Array.isArray(response) ? response : (response.rows || [])
          this.allUsers = rows
          this.nothing = this.allUsers.length === 0
          this.isLoading = false
        })
        .catch(error => {
          console.log(error)
          this.allUsers = []
          this.nothing = true
          this.isLoading = false
        })
    },
    loadAllUsers () {
      this.isLoading = true
      http.post(apiRoutes.baseURL + apiRoutes.getAllUser, {
        type: 'USER',
        page: 1,
        limit: 10000
      }, {
        headers: { Authorization: `Bearer ${this.$store.getters.loginToken}` }
      })
        .then(response => {
          this.allUsers = response.rows || []
          this.nothing = this.allUsers.length === 0
          this.isLoading = false
        })
        .catch(error => {
          console.log(error)
          this.isLoading = false
        })
    },
    loadParrainageForVisible (users) {
      if (!users || users.length === 0) return
      users.forEach(user => {
        if (user && user.userId && !this.parainageByUser[user.userId]) {
          http.post(apiRoutes.baseURL + apiRoutes.getParrainage,
            { userId: user.userId },
            { headers: { Authorization: `Bearer ${this.$store.getters.loginToken}` } }
          )
            .then(response => {
              this.$set(this.parainageByUser, user.userId, response.total || 0)
            })
            .catch(error => { console.log('Erreur parrainage pour userId', user.userId, ':', error) })
        }
      })
    },
    getListTown () {
      http.get('https://bj-decoupage-territorial.herokuapp.com/api/v1/towns')
        .then(response => { this.statusList = response.towns })
        .catch(error => { console.log(error) })
    },
    showUserDetail (item) {
      this.userDetails = true
      this.selectedItem = item
    },
    closeUsersDetail (val) {
      this.userDetails = val
    },
    selectedValueProfession (answer) {
      this.selectedProfession = answer
    },
    selectedValue (answer) {
      this.trieOption = answer
    },
    onCancel () {
      console.log('User cancelled the loader.')
    },
    openPromoteConfirm (user) {
      this.userToPromote = user
      this.promoteError = false
      this.promoteErrorMessage = ''
      this.promoteConfirm = true
    },
    closePromoteConfirm () {
      this.promoteConfirm = false
      this.userToPromote = null
    },
    promoteUser () {
      if (!this.userToPromote) return
      const u = this.userToPromote
      const email = (u.user && u.user.email) || u.email
      const phone = u.phone
      if (!email || !phone) {
        this.promoteError = true
        this.promoteErrorMessage = 'Email ou téléphone manquant pour cet utilisateur'
        return
      }
      this.promoteLoader = true
      this.promoteError = false
      http.post(apiRoutes.baseURL + apiRoutes.promoteAdmin, {
        phone: phone,
        email: email,
        role: ['SUPER_ADMIN']
      }, {
        headers: { Authorization: `Bearer ${this.$store.getters.loginToken}` }
      }).then(response => {
        console.log(response)
        this.promoteConfirm = false
        this.promoteMessage = 'Utilisateur promu Super Admin avec succès'
        this.promoteSuccess = true
      }).catch(error => {
        console.log(error)
        this.promoteError = true
        this.promoteErrorMessage = (error.data && error.data.message) || 'Erreur lors de la promotion'
      }).finally(() => {
        this.promoteLoader = false
      })
    },
    closePromoteSuccess () {
      this.promoteSuccess = false
      this.userToPromote = null
      this.loadAllUsers()
    },
    openSuspendConfirm (user) {
      this.userToChangeStatus = user
      this.statusAction = 'suspend'
      this.statusError = false
      this.statusErrorMessage = ''
      this.statusConfirm = true
    },
    openReactivateConfirm (user) {
      this.userToChangeStatus = user
      this.statusAction = 'reactivate'
      this.statusError = false
      this.statusErrorMessage = ''
      this.statusConfirm = true
    },
    closeStatusConfirm () {
      this.statusConfirm = false
      this.userToChangeStatus = null
      this.statusAction = ''
    },
    confirmStatusChange () {
      if (!this.userToChangeStatus || !this.statusAction) return
      const u = this.userToChangeStatus
      const userId = (u.user && u.user.id) || u.userId || u.id
      if (!userId) {
        this.statusError = true
        this.statusErrorMessage = 'Identifiant utilisateur introuvable'
        return
      }
      const route = this.statusAction === 'suspend' ? apiRoutes.suspendUser : apiRoutes.reactivateUser
      this.statusLoader = true
      this.statusError = false
      http.patch(apiRoutes.baseURL + route + userId, {}, {
        headers: { Authorization: `Bearer ${this.$store.getters.loginToken}` }
      }).then(response => {
        console.log(response)
        this.statusConfirm = false
        this.statusMessage = this.statusAction === 'suspend'
          ? 'Utilisateur suspendu avec succès'
          : 'Utilisateur réactivé avec succès'
        this.statusSuccess = true
      }).catch(error => {
        console.log(error)
        this.statusError = true
        this.statusErrorMessage = (error.data && error.data.message) || 'Erreur lors de l\'opération'
      }).finally(() => {
        this.statusLoader = false
      })
    },
    closeStatusSuccess () {
      this.statusSuccess = false
      this.userToChangeStatus = null
      this.statusAction = ''
      if (this.viewMode === 'inactive') {
        this.loadInactiveUsers()
      } else {
        this.loadAllUsers()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "src/assets/style/sass/variables";
  .users {
    padding: 2rem 4rem 4rem 1.5rem;
  }
  .user-list {
    color: $light_gray;
  }
  .loading {
    position: relative;
    height: 10vh;
  }
  .not_empty {
    height: auto;
  }
</style>
